import { __decorate } from "tslib";
import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
export const SpaceTagsModel = Symbol('SpaceTagsModel');
let SpaceTagsModelImp = class SpaceTagsModelImp extends AbstractModel {
    constructor() {
        super(...arguments);
        this._modelData = [];
    }
    dispose() {
        this.update(() => []);
    }
};
SpaceTagsModelImp = __decorate([
    injectable()
], SpaceTagsModelImp);
export { SpaceTagsModelImp };
